var DialogQuotationModule = /** @class */ (function () {
    function DialogQuotationModule() {
    }
    return DialogQuotationModule;
}());
export { DialogQuotationModule };
